import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { classNames } from "../../helpers/classNames";

const AccordionItem = ({
  title,
  content,
  isOpen,
  onToggle,
  buttonClass,
  contentClass,
}) => (
  <div className="relative bg-white rounded-lg overflow-hidden shadow shadow-md-pink/20">
    <button
      onClick={onToggle}
      className={classNames(
        "flex w-full items-center justify-between px-6 py-6 text-left text-2xl 3xl:text-3xl font-medium transition-all duration-300",
        buttonClass
      )}
    >
      <span className={classNames("transition-all duration-300",isOpen?"text-md-pink":"text-md-dark")}>{title}</span>
      <i
        className={classNames(
          "ml-auto text-md-pink fa-regular transition-all duration-300 fa-angle-up",
          isOpen ? "rotate-0" : "rotate-180"
        )}
      ></i>
    </button>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          key="content"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="overflow-hidden border-t border-md-pink-light-1"
        >
          <div
            className={classNames(
              "px-6 py-6 text-lg 3xl:text-xl tracking-wide leading-relaxed text-neutral-600",
              contentClass
            )}
          >
            {content}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default function Accordion({
  data = [],
  buttonClass,
  contentClass,
  className,
}) {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="w-full">
      <div className={classNames("mx-auto w-full space-y-4", className)}>
        {data?.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.title}
            content={item.content}
            isOpen={openIndex === index}
            onToggle={() => handleToggle(index)}
            buttonClass={buttonClass}
            contentClass={contentClass}
          />
        ))}
      </div>
    </div>
  );
}
